import { faRocket } from '@fortawesome/pro-regular-svg-icons';
import { Flex } from 'portal-commons';

import RcsSectionBlock from './RcsSectionBlock';
import InfoItem from './InfoItem';
import InfoItemLayout from './InfoItemLayout';
import { CampaignDetail } from '@/apis/core/types';

interface LaunchDetailsSectionProps {
  campaign?: CampaignDetail;
}

const LaunchDetailsSection = ({ campaign }: LaunchDetailsSectionProps) => {
  return (
    <RcsSectionBlock
      icon={faRocket}
      title="Launch Details"
      showDivider={true}
      data-testid="campaignLaunchDetails"
    >
      <Flex
        sx={{
          flexDirection: 'column',
          gap: 's',
        }}
      >
        <InfoItemLayout.Horizontal>
          <InfoItem title="Action Trigger Messages">
            {campaign?.actionTriggerMessages}
          </InfoItem>
          <InfoItem title="Types of Messages Sent">
            {campaign?.messageTypes}
          </InfoItem>
        </InfoItemLayout.Horizontal>
        <InfoItemLayout.Horizontal>
          <InfoItem title="Opt-In">{campaign?.optinFlow}</InfoItem>
          <InfoItem title="Opt-Out">{campaign?.optoutFlow}</InfoItem>
        </InfoItemLayout.Horizontal>
        <InfoItemLayout.Horizontal>
          <InfoItem title="Screenshot URL">{campaign?.screenshotUrl}</InfoItem>
          <InfoItem title="Video URL">{campaign?.videoUrl}</InfoItem>
        </InfoItemLayout.Horizontal>
      </Flex>
    </RcsSectionBlock>
  );
};

export default LaunchDetailsSection;
